// src/components/ModeloTable/ModeloTable.jsx
import React from 'react';
import styles from './ModeloTable.module.scss';

const ModeloTable = ({ specs }) => {
  const remainingSpecs = specs.slice(3);

  if (remainingSpecs.length === 0) {
    return <p>No hay más especificaciones disponibles.</p>;
  }

  return (
    <div className={styles.modeloTableContainer}>
      <h3 className={styles.modeloTableTitle}>Ventajas adicionales</h3>
      <table className={styles.modeloSpecsTable}>
        <thead>
          <tr>
            <th>Especificación</th>
            <th>Valor</th>
          </tr>
        </thead>
        <tbody>
          {remainingSpecs.map((spec, index) => (
            <tr key={index}>
              <td>{spec.name}</td>
              <td>{spec.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ModeloTable;
